import { render, staticRenderFns } from "./DiscoveryTabOverview.vue?vue&type=template&id=67487ceb&scoped=true&"
import script from "./DiscoveryTabOverview.vue?vue&type=script&lang=js&"
export * from "./DiscoveryTabOverview.vue?vue&type=script&lang=js&"
import style0 from "./DiscoveryTabOverview.vue?vue&type=style&index=0&id=67487ceb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67487ceb",
  null
  
)

export default component.exports